import * as React from "react"
import * as _ from "lodash"
import {connect} from "react-redux";
import {ModalComponent} from "../components/ModalComponent";
import RollbarUtils from "../utils/RollbarUtils";
import {LOADING_STATE} from "../utils/AppUtils";
import {IAppState} from "../models/IAppState";
import IDoctorProfile from "../models/IDoctorProfile";
import { ORION_IMG_URL } from "../utils/AppConstants";

export interface ErrorContainerProps {
    errorText: string,
    errorCode?: number,
    errorDetails?: string,
    closeError?: () => void,
    keepPadding?: boolean,
    reportError?: boolean,
    rollbarPayload?: any
}

export interface ErrorContainerState {
    errorDetailsVisibility?: boolean,
    rollbarLoggingStatus?: LOADING_STATE,
    rollbarLoggingSuccess?: boolean
}

class ErrorContainer extends React.Component<ErrorContainerProps & IStateProps, ErrorContainerState> {
    constructor(props: ErrorContainerProps & IStateProps) {
        super(props);
        this.state = {
            errorDetailsVisibility: true,
            rollbarLoggingStatus: LOADING_STATE.NOT_INITIALIZED,
            rollbarLoggingSuccess: null
        }
    }

    toggleErrorDetails = () => {
        this.setState({
            errorDetailsVisibility: true
        })
    }

    rollbarCallback = (err: any, data: any) => {
        if (!_.isNull(err)) {
            this.setState({
                rollbarLoggingStatus: LOADING_STATE.LOADED,
                rollbarLoggingSuccess: false
            })
        } else {
            this.setState({
                rollbarLoggingStatus: LOADING_STATE.LOADED,
                rollbarLoggingSuccess: true
            })
        }
    }

    reportError = () => {
        if (!this.state.rollbarLoggingSuccess) {
            let error = new Error(this.props.errorText);
            let payload = { ...this.props.rollbarPayload, doctorId: this.props.doctorProfile.id, doctorName: this.props.doctorProfile.name }
            this.setState({
                rollbarLoggingStatus: LOADING_STATE.LOADING
            }, () => {
                RollbarUtils.sendErrorToRollbar(error, payload, this.rollbarCallback)
            })
        }
    }

    render() {
        let errorCode = this.props.errorCode !== undefined && this.props.errorCode !== 0 ? `${this.props.errorCode} :` : "";
        let errorText = `${errorCode} ${this.props.errorText}`
        let errorDetails = this.props.errorDetails;
        let padding = this.props.keepPadding !== undefined ? this.props.keepPadding : true;
        let glyphiconCssClass = this.props.errorCode !== undefined ? "glyphicon glyphicon-remove" : "glyphicon glyphicon-ok";
        let reportButtonCssClass = this.state.rollbarLoggingSuccess ? "success" : "";
        let reportButtonText = this.state.rollbarLoggingSuccess ? "Reported" : "Report";
        return (
            <ModalComponent modalSize={"x-small"} keepPadding={padding}>
                <div className={"error-top-container animated slideInDown"}>
                    <div className={"error-header"}>
                        <span className={glyphiconCssClass}></span>
                    </div>
                    <div className={"error-text"}>{errorText}</div>
                    {
                        !_.isEmpty(errorDetails) &&
                        <div className={"error-details"}>
                            {
                                !this.state.errorDetailsVisibility &&
                                <div className={`error-details-label`} onClick={this.toggleErrorDetails}>Error details</div>
                            }
                            {
                                this.state.errorDetailsVisibility &&
                                <div className={`error-details-content animated fadeIn`}>{errorDetails}</div>
                            }
                        </div>
                    }
                    <div className={"close-error-message"}>
                        {
                            this.props.reportError &&
                            <div className={`button ${reportButtonCssClass}`} onClick={this.reportError}>
                                {
                                    this.state.rollbarLoggingStatus === LOADING_STATE.LOADING ?
                                        <img className={"loader"} src={ORION_IMG_URL + "loader/rolling-loader.gif"} /> :
                                        <span>
                                            {reportButtonText}
                                            { this.state.rollbarLoggingSuccess && <span className={"glyphicon glyphicon-ok"} /> }
                                        </span>
                                }
                            </div>
                        }
                        <div className={"button"} onClick={this.props.closeError}>Close</div>
                    </div>
                </div>
            </ModalComponent>
        )
    }
}

interface IStateProps {
    doctorProfile: IDoctorProfile
}

const mapStateToProps = (state: IAppState) => {
    return {
        doctorProfile: state.doctorProfile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {}
}

export default connect<IStateProps, any, ErrorContainerProps>(mapStateToProps, mapDispatchToProps)(ErrorContainer);